export default __webpack_public_path__ + "static/media/Prologue_Kyo1US.b15cf582.png";